import Button from "@/components/common/Button";
import { UsersIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

interface EmployeeHeaderProps {
  isDepartmentAdmin: boolean;
  onInviteClick: () => void;
}

const EmployeeHeader = ({ isDepartmentAdmin, onInviteClick }: EmployeeHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 bg-gradient-to-r from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 p-4 sm:p-6 shadow-sm">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-primary-100 to-primary-200 dark:from-primary-900 dark:to-primary-800 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
            <UsersIcon className="h-6 w-6 sm:h-7 sm:w-7 text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
              {t("admin.employees", "Employees")}
            </h1>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">
              {isDepartmentAdmin 
                ? t("admin.departmentEmployeesDescription", "View and manage employees in your department")
                : t("admin.manageEmployees", "Manage your company employees")
              }
            </p>
          </div>
        </div>
        <Button
          variant="primary"
          leftIcon={<UsersIcon className="h-4 w-4 sm:h-5 sm:w-5" />}
          onClick={onInviteClick}
          className="w-full sm:w-auto bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 shadow-lg hover:shadow-xl text-sm sm:text-base whitespace-nowrap"
        >
          {t("admin.inviteEmployees", "Invite Employees")}
        </Button>
      </div>
    </div>
  );
};

export default EmployeeHeader;
